import {
  GET_NOA_TRACKING,
  POST_NOA_TRACKING,
  PUT_NOA_TRACKING,
  DELETE_NOA_TRACKING,
  GET_NOA_COMPUTED_VALUES,
} from "../constants/actionTypes";

const defaultState = {
  noaTrackingArr: [],
  noaTracking: {},
  computedValues: {},
};
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_NOA_TRACKING:
        return { ...state, noaTrackingArr: [...action.payload] };
      case GET_NOA_COMPUTED_VALUES:
        return { ...state, computedValues: { ...action.payload } };
      case POST_NOA_TRACKING:
        return { ...state, noaTrackingArr: [...state.noaTrackingArr, action.payload] };
      case PUT_NOA_TRACKING:
        let data = [...state.noaTrackingArr];
        index = data.findIndex((item) => item?.id === action.payload?.id);
        if (index !== -1) data[index] = { ...action.payload };
        return { ...state, noaTrackingArr: [...data] };
      case DELETE_NOA_TRACKING:
        return {
          ...state,
          noaTrackingArr: state.noaTrackingArr.filter((item) => item?.id !== action.payload),
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
